import { STORAGE_ERROR } from '@/services/storage/constants'

class StorageService {
  get<T>(key: string): T | null {
    try {
      const value = localStorage.getItem(key)

      return value ? JSON.parse(value) : null
    } catch (error) {
      console.error(STORAGE_ERROR.get(key), error)

      return null
    }
  }

  set(key: string, value: any) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.error(STORAGE_ERROR.set(key), error)
    }
  }

  remove(key: string) {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error(STORAGE_ERROR.remove(key), error)
    }
  }
}

export const storage = new StorageService()
